import { getEntityById } from '@core/utils/collection';
import type { Color } from '../../api/color';
import type { Fabric } from '../../api/fabric';

export type FabricFlag = Extract<
  keyof Fabric,
  | 'isChasubleBody'
  | 'isChasublePanel'
  | 'isAlbBody'
  | 'isStolePanel'
  | 'isStolePatching'
  | 'isMitreBody'
  | 'isMitrePanel'
  | 'isMitreLining'
>;

export function filterFabricsByFlag(
  fabrics: Fabric[],
  flag: FabricFlag
): Fabric[] {
  return fabrics.filter((fabric) => Boolean(fabric[flag]));
}

export function getColorsForFabric(fabric: Fabric | undefined): Color[] {
  return fabric?.colors ?? [];
}

export function isColorLinkedToFabric(
  fabric: Fabric | undefined,
  colorId: string
): boolean {
  if (!fabric || !colorId.trim()) {
    return false;
  }
  return fabric.colors.some((color) => String(color.id) === colorId);
}

export function getFabricColorOptions(
  fabric: Fabric | undefined,
  allColors: Color[],
  selectedColorId?: string
): Color[] {
  const linkedColors = getColorsForFabric(fabric);
  if (!selectedColorId?.trim()) {
    return linkedColors;
  }

  const selectedColor = getEntityById(allColors, selectedColorId);
  if (
    selectedColor &&
    !linkedColors.some((color) => color.id === selectedColor.id)
  ) {
    return [...linkedColors, selectedColor];
  }

  return linkedColors;
}
